module.exports = __webpack_public_path__ + "static/media/puzzle0302.ea79a55e.jpg";